import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';
import { useAuth } from '../lib/auth.jsx';

export default function Admin() {
  const { user } = useAuth();
  const [log, setLog] = useState([]);
  const [msgs, setMsgs] = useState([]);
  const [simProto, setSimProto] = useState('hl7v2');
  const [simType, setSimType] = useState('ADT_A01');
  const [simPayload, setSimPayload] = useState('MSH|^~\\&|EPIC|MERCY-EAST|M2B|MERCY-EAST|20260423120000||ADT^A01|SIM00001|P|2.5\rPID|1||MRN3001^^^MERCY-EAST^MR||Demo^Override^A||19701101|M\rPV1|1|I|ICU^301^A');
  const [simResult, setSimResult] = useState(null);

  async function load() {
    const [a, m] = await Promise.all([
      user.role === 'admin' ? api.auditLog() : Promise.resolve({ audit_logs: [] }),
      api.intMessages(),
    ]);
    setLog(a.audit_logs || []);
    setMsgs(m.messages);
  }
  useEffect(() => { load().catch(console.error); }, []);

  async function simulate() {
    const payload = simProto === 'hl7v2' ? simPayload : JSON.parse(simPayload);
    const r = await api.simulate({ protocol: simProto, message_type: simType, payload });
    setSimResult(r);
    load();
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Admin</h1>

      <div className="card p-4">
        <h2 className="font-semibold mb-3">Integration Simulator</h2>
        <p className="text-xs text-slate-500 mb-3">Inject a sample HL7/FHIR/PMS message to test parsers, normalizer, and rules.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-2">
          <select className="input" value={simProto} onChange={e => setSimProto(e.target.value)}>
            <option value="hl7v2">HL7 v2</option>
            <option value="fhir">FHIR R4</option>
            <option value="pms_rest">PMS REST</option>
          </select>
          <input className="input" value={simType} onChange={e => setSimType(e.target.value)} placeholder="Message type (ADT_A01, Patient, pioneerrx)" />
          <button onClick={simulate} className="btn-primary">Run Simulation</button>
        </div>
        <textarea rows={6} className="input font-mono text-xs" value={simPayload} onChange={e => setSimPayload(e.target.value)} />
        {simResult && (
          <pre className="mt-3 text-xs bg-slate-50 p-3 rounded border border-slate-200 overflow-auto max-h-64">{JSON.stringify(simResult, null, 2)}</pre>
        )}
      </div>

      <div className="card p-4">
        <h2 className="font-semibold mb-3">Integration Messages (last 100)</h2>
        <table className="w-full text-xs">
          <thead className="text-slate-500 uppercase text-left">
            <tr><th>Time</th><th>Proto</th><th>Type</th><th>Dir</th><th>Status</th><th>Error</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {msgs.map(m => (
              <tr key={m.id}>
                <td className="py-1">{new Date(m.received_at).toLocaleTimeString()}</td>
                <td>{m.protocol}</td>
                <td>{m.message_type}</td>
                <td>{m.direction}</td>
                <td><span className={`badge-${m.status === 'succeeded' ? 'success' : m.status === 'failed' ? 'critical' : 'neutral'}`}>{m.status}</span></td>
                <td className="text-red-600">{m.error_message}</td>
              </tr>
            ))}
            {msgs.length === 0 && <tr><td colSpan={6} className="py-4 text-center text-slate-400">No integration messages yet</td></tr>}
          </tbody>
        </table>
      </div>

      {user.role === 'admin' && (
        <div className="card p-4">
          <h2 className="font-semibold mb-3">Audit Log</h2>
          <table className="w-full text-xs">
            <thead className="text-slate-500 uppercase text-left">
              <tr><th>Time</th><th>Actor</th><th>Action</th><th>Target</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {log.map(l => (
                <tr key={l.id}>
                  <td className="py-1">{new Date(l.occurred_at).toLocaleString()}</td>
                  <td>{l.actor_role}</td>
                  <td><span className="badge-info">{l.action}</span></td>
                  <td>{l.target_type}/{l.target_id?.slice(0,8)}</td>
                </tr>
              ))}
              {log.length === 0 && <tr><td colSpan={4} className="py-4 text-center text-slate-400">No audit entries</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
